import NewNotificationBell from "../../assets/svg/NewNotificationBell.svg";
import NewNotificationBellDot from "../../assets/svg/NewNotificationBellDot.svg";
import { useEffect, useMemo, useState, type MouseEvent } from "react";
import { useUser } from "@/hooks/useUser";
import useAllNotificationQuery, {
  NotificationType,
} from "@/api/query/useAllNotificationQuery";
import { io } from "socket.io-client";
import { baseURL, requestURLs } from "@/Environment";
import ApiRequest from "@/api/ApiRequest";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import { toast } from "react-toastify";
import Dialog from "../common/Dialog";
import useReadAllNotificationMutation from "@/api/mutation/useReadAllNotificationMutation";
import UserAvatar from "../ui/userAvatar";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { SideBarNewProps } from "./SidebarNew";
import HamburgerIcon from "@/assets/svg/Hamburger.svg";
import { errorConfig } from "@/lib/toastError";
import UserIcon from "@/assets/v2/svg/profile.svg";
import crossNew from "@/assets/svg/crossNew.svg";
import NewLogout from "../../assets/v2/svg/log-out.svg";
import { useAuth } from "@/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/api/query/querykeys";
import useNotificationHistoryQuery from "@/api/query/useNotificationHistoryQuery";
import { NotificationRowContent } from "@/components/notifications/NotificationRowContent";
import MySubscription from "@/assets/v2/svg/subscription.svg";
import usePaymentStatusQuery from "@/api/query/usePaymentStatusQuery";
import GreenChackMark from "@/assets/svg/GreenChackMark.svg";
import RedCharmTick from "@/assets/svg/RedCharmTick.svg";
import PhoneTelephone from "@/assets/svg/PhoneTelephone.svg";
import Spinner from "../ui/spinner";
import useCurrentUserQuery from "@/api/query/useCurrentUserQuery";
import {
  ExtendPlanTypeEnumSchema,
  PlanTypeEnumSchema,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import BackIcon from "@/assets/svg/NewLetsIconsBack.svg";
import useUserProfileUpdateMutation from "@/api/mutation/useUserProfileUpdateMutation";
import HelpIcon from "@/assets/v2/svg/help-icon.svg";
import useProjectWithoutCalulationQuery from "@/api/query/useProjectWithoutCalulationQuery";
import { isTimesheetAccessible } from "@/utils/paywallUtils";
import { ChevronRight, Trash2, AlertTriangle, CheckCircle2 } from "lucide-react";
import { getNotificationClickPath } from "@/utils/notificationPresentation";
import { useDeleteNotificationMutation } from "@/api/mutation/useDeleteNotificationMutation";
import { useClearAllNotificationsMutation } from "@/api/mutation/useClearAllNotificationsMutation";

const NOTIFICATION_PREVIEW_COUNT = 3;

export const NavbarNew = (props: SideBarNewProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [notifications, setNotifications] = useState<NotificationType[]>([]);
  const [isOpenPopUpRead, setisOpenPopUpRead] = useState(false);
  const [isOpenClearAllNotifications, setIsOpenClearAllNotifications] =
    useState(false);
  const [notificationDropdownOpen, setNotificationDropdownOpen] =
    useState(false);
  const [notificationListExpanded, setNotificationListExpanded] =
    useState(false);
  const useAllNotification = useAllNotificationQuery();
  const notificationHistoryQuery = useNotificationHistoryQuery(
    notificationDropdownOpen,
  );

  /** Unread list wins over history for the same id (socket / latest reads). */
  const mergedDropdownNotifications = useMemo(() => {
    const history = notificationHistoryQuery.data?.data?.data ?? [];
    const byId = new Map<string, NotificationType>();
    for (const n of history) {
      byId.set(n.notificationId, n);
    }
    for (const n of notifications) {
      byId.set(n.notificationId, n);
    }
    return Array.from(byId.values()).sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    );
  }, [notifications, notificationHistoryQuery.data?.data?.data]);

  const displayedDropdownNotifications = notificationListExpanded
    ? mergedDropdownNotifications
    : mergedDropdownNotifications.slice(0, NOTIFICATION_PREVIEW_COUNT);

  const showViewAllNotificationsFooter =
    !notificationListExpanded &&
    mergedDropdownNotifications.length > NOTIFICATION_PREVIEW_COUNT;

  const { user } = useUser();
  const useReadAllNotification = useReadAllNotificationMutation();
  const deleteNotificationMutation = useDeleteNotificationMutation();
  const clearAllNotificationsMutation = useClearAllNotificationsMutation();
  const projectQuery = useProjectWithoutCalulationQuery(!!user);
  const { projectId, id, organisationId } = useParams();
  const [projectName, setprojectName] = useState<string>();
  const navigate = useNavigate();
  const urlLocation = window.location.pathname.split("/")[1];
  const { logout } = useAuth();
  const [isShowVideo, setIsShowVideo] = useState(false);
  const location = useLocation();
  // const [openMySubscriptions, setOpenMySubscriptions] = useState(false);
  const [isPaymentSuccess, setIsPaymentSuccess] = useState<{
    loading: boolean;
    status: "PENDING" | "SUCCESS" | "ERROR";
  }>({
    loading: false,
    status: "PENDING",
  });
  useEffect(() => {
    if (!projectQuery.isFetched && user?.userOrganisation[0]?.organisationId) {
      projectQuery.refetch()
    }
    const project = projectQuery.data?.data.data.find(
      (project) => project.projectId == (projectId ?? id),
    )?.projectName;
    setprojectName(project);
  }, [projectId, id, projectQuery.data?.data.data, urlLocation]);

  const [filter, setFilter] = useSearchParams();
  const paymentStatus = usePaymentStatusQuery(filter.get("session_id") ?? "");
  const userQuary = useCurrentUserQuery();
  const [isShowRiskVideo, setIsShowRiskVideo] = useState(false);
  const [roadmapVideo, setRoadmapVideo] = useState(false);

  useEffect(() => {
    if (
      user &&
      user.subscription?.customerId === ExtendPlanTypeEnumSchema.FREE_TRIAL
    ) {
      const start = new Date(user.subscription.startDate);
      const today = new Date();

      // Normalize both to midnight (optional but avoids timezone issues)
      start.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      const diffMs = today.getTime() - start.getTime();
      const passedDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      const totalTrialDays = 14; // or 1 for testing
      // const totalTrialDays = 1; // or 1 for testing
      const remainingDays = Math.max(totalTrialDays - passedDays, 0);

      if (remainingDays <= 3 && remainingDays > 0) {
        toast.success(
          <div className="flex items-center">
            <p className="text-wrap">
              {t("last_few_days_message", { daysLeft: remainingDays })} &nbsp;
            </p>
            <div className="">
              <button
                onClick={() =>
                  window.open("https://calendly.com/projectchef/45min")
                }
                className="border-b border-b-white outline-none mt-1 ml-auto"
              >
                {t("discuss")}
              </button>
            </div>
          </div>,
          { toastId: "user_info", autoClose: false },
        );
      }
    }
  }, [user]);

  useEffect(() => {
    if (filter.get("session_id")) {
      setIsPaymentSuccess({ loading: true, status: "PENDING" });
      paymentStatus.refetch().then((res: any) => {
        if (res?.data?.data?.data?.status === "complete") {
          setIsPaymentSuccess({ loading: true, status: "SUCCESS" });
          userQuary.refetch();
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjects] });
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjectsNocal] });
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.portfolioDashboard] });
          toast.error(`${t("user_alert_message")}`, {
            toastId: "user_alert",
            autoClose: false,
          });
        } else {
          setIsPaymentSuccess({ loading: true, status: "ERROR" });
        }
      });
    }
    if (filter.get("organization")) {
      navigate("/organisation/" + user?.userOrganisation[0].organisationId, {
        state: { tab: 3 },
      });
    }
  }, [location, filter]);

  useEffect(() => {
    if (window.location.pathname == "/projects") {
      if (
        !user?.isTutorialShow &&
        user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR
      ) {
        setIsShowVideo(true);
      }
    }
  }, [user, location]);

  useEffect(() => {
    setNotifications(useAllNotification.data?.data.data ?? []);
  }, [useAllNotification.data?.data.data]);

  useEffect(() => {
    if (!user?.userId) {
      return;
    }

    const socket = io(baseURL, {
      path: "/socket.io",
      transports: ["websocket"],
      reconnectionAttempts: 3,
      timeout: 2000,
      query: {
        roomName: user.userId,
      },
    });
    socket.emit("join", user.userId);
    socket.on("notification", (notificationObject) => {
      if (!notificationObject?.notificationId) return;
      const incoming: NotificationType = {
        notificationId: notificationObject.notificationId,
        type: notificationObject.type,
        referenceId: notificationObject.referenceId,
        sentBy: notificationObject.sentBy,
        sentTo: notificationObject.sentTo,
        details: notificationObject.details,
        isRead: notificationObject.isRead,
        createdAt: notificationObject.createdAt,
        ReadAt: notificationObject.ReadAt,
        sentNotificationBy: notificationObject.sentNotificationBy,
        sentNotificationTo: notificationObject.sentNotificationTo,
        task: notificationObject.task,
      };
      // Merge into current list — do not read react-query here (stale closure after first event).
      setNotifications((prev) => {
        const rest = prev.filter(
          (n) => n.notificationId !== incoming.notificationId,
        );
        return [...rest, incoming].sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        );
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.allNotification],
      });
    });
    socket.on("logout", (logout) => {
      if (logout) {
        toast.error(
          <div className="lg:flex gap-1 items-center">
            <p className=" text-wrap">
              {t(
                "We have released a new version. Please log out and log in to see the latest version.",
              )}
              <br />
            </p>
            <div className="flex justify-end items-center">
              <button
                onClick={() => window.location.reload()}
                className="border-b border-b-white outline-none mt-1 text-xs"
              >
                {t("reload")}
              </button>
            </div>
          </div>,
          { autoClose: false },
        );
      }
    });

    return () => {
      socket.off("notification");
      socket.off("logout");
      socket.disconnect();
    };
  }, [user?.userId, queryClient, t]);

  const handleReadAll = () => {
    useReadAllNotification.mutate(undefined, {
      onSuccess(data) {
        toast.success(data.data.message);
        setNotifications([]);
        void queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.notificationHistory],
        });
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message + ""),
          errorConfig,
        );
      },
    });
  };

  const handleNotificationNavigateAndRead = async (
    notification: NotificationType,
  ) => {
    const path = getNotificationClickPath(notification);
    navigate(path);
    setNotificationDropdownOpen(false);
    if (notification.isRead) return;
    try {
      await ApiRequest.put(
        `${requestURLs.notification}${notification.notificationId}`,
        notification,
      );
      setNotifications((prev) =>
        prev.filter((n) => n.notificationId !== notification.notificationId),
      );
      void queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.notificationHistory],
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.allNotification],
      });
    } catch {
      /* ignore */
    }
  };

  const handleDeleteNotification = (
    e: MouseEvent,
    notification: NotificationType,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    deleteNotificationMutation.mutate(notification.notificationId, {
      onSuccess: () => {
        setNotifications((prev) =>
          prev.filter((n) => n.notificationId !== notification.notificationId),
        );
      },
      onError: (error) => {
        toast.error(
          errorKeyFormate(
            (error as { response?: { data?: { message?: string } } }).response
              ?.data?.message + "",
          ),
          errorConfig,
        );
      },
    });
  };

  const handleClearAllNotificationsConfirmed = () => {
    clearAllNotificationsMutation.mutate(undefined, {
      onSuccess: (data) => {
        toast.success(data.message);
        setNotifications([]);
        setIsOpenClearAllNotifications(false);
        void queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.notificationHistory],
        });
        void queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.allNotification],
        });
      },
      onError: (error) => {
        toast.error(
          errorKeyFormate(
            (error as { response?: { data?: { message?: string } } }).response
              ?.data?.message + "",
          ),
          errorConfig,
        );
      },
    });
  };
  const [isMobailView, setIsMobailView] = useState(false);
  useEffect(() => {
    // setIsMobailView(window.outerWidth < 768);
    setIsMobailView(false);
  }, []);

  const [confirmDashboard, setConfirmDashboard] = useState(false);
  useEffect(() => {
    const isTimesheetRoute =
      urlLocation == "my-timesheet" || urlLocation == "timesheet-approvals";

    if (isTimesheetRoute && !isTimesheetAccessible(user)) {
      setConfirmDashboard(true);
      return;
    }

    if (
      user?.subscription?.customerId === ExtendPlanTypeEnumSchema.FREE_TRIAL
    ) {
      setConfirmDashboard(false);
      return;
    } else if (
      (urlLocation == "projectDashboard" ||
        urlLocation == "" ||
        urlLocation == "capacity-planning" ||
        urlLocation == "risk" ||
        urlLocation == "workload") &&
      (user?.subscription?.planType == PlanTypeEnumSchema.FREE ||
        !user?.subscription)
    ) {
      setConfirmDashboard(true);
    } else {
      setConfirmDashboard(false);
    }
  }, [location.pathname, user, urlLocation]);

  const userProfileUpdateMutation = useUserProfileUpdateMutation();
  const currentUserQuery = useCurrentUserQuery();
  const setIsTutorialShow = () => {
    userProfileUpdateMutation.mutate(
      {
        isTutorialShow: true,
        firstName: user?.firstName || "",
        lastName: user?.lastName || "",
        email: user?.email || "",
      },
      {
        onSettled() {
          currentUserQuery.refetch();
        },
      },
    );
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      const navbar = document.getElementById("navbar");
      const sidebar = document.getElementById("Sidebar");

      if (document.fullscreenElement) {
        if (navbar) navbar.classList.add("!hidden");
        if (sidebar) sidebar.classList.add("!hidden");
      } else {
        if (navbar) navbar.classList.remove("!hidden");
        if (sidebar) sidebar.classList.remove("!hidden");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  return (
    <>
      <div
        className="flex justify-between items-center w-full z-20 py-1.5 px-6 bg-white/80 backdrop-blur-md sticky top-0 gap-2 h-14 border-b border-slate-100/60 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.02)] transition-all duration-300"
        id="navbar"
      >
        {isMobailView && (
          <div onClick={() => props.setOpen(true)}>
            <img src={HamburgerIcon} className="h-4 w-4" />
          </div>
        )}
        <div
          className={`text-[13px] flex justify-between items-center w-full truncate h-fit text-slate-800 font-extrabold uppercase tracking-wider`}
        >
          {projectName ? (
            location.pathname.includes("tasks") ? (
              t("project_tasks") + " : " + projectName
            ) : location.pathname.includes("workload") ? (
              t("project_workload") + " : " + projectName
            ) : location.pathname.includes("member") ? (
              t("project_members")
            ) : location.pathname.includes("risk") ? (
              t("Risk Management") + " : " + projectName
            ) : location.pathname.includes("project-details") ? (
              t("project_settings")
            ) : (
              <div className="text-base lg:text-lg font-semibold">
                {t("project_dashboard")}
              </div>
            )
          ) : projectQuery.data?.data.data.find(
            (item) => item.organisationId === organisationId,
          ) && location.pathname.includes("organization-details") ? (
            t("organization-details")
          ) : location.pathname.includes("nonworking-days") ? (
            t("nonworking-days")
          ) : location.pathname.includes("project-settings") ? (
            t("project_settings")
          ) : location.pathname.includes("timesheet-settings") ? (
            t("timesheet_settings")
          ) : location.pathname.includes("risk-settings") ? (
            t("riskSettings")
          ) : location.pathname.includes("kpi-settings") ? (
            t("kpi_settings")
          ) : location.pathname.includes("settings") ? (
            t("settings")
          ) : location.pathname.includes("api-integration") ? (
            t("integrations")
          ) : location.pathname.includes("capacity-planning") ? (
            t("Workload Planning")
          ) : location.pathname.includes("organization-member") ? (
            t("resources")
          ) : location.pathname.includes("job-titles") ? (
            t("job-titles")
          ) : location.pathname.includes("resource-administration") ? (
            t("resource_admin_title")
          ) : location.pathname.includes("manage-absence") ? (
            t("availability")
          ) : location.pathname.includes("account-settings") ? t("my_profile") : location.pathname === "/plans" ? t("MySubscriptions") : (
            ""
          )}

          {projectQuery.data?.data.data?.length == 0 &&
            urlLocation == "projects" && (
              <div className="flex items-center w-full">
                <div>👋</div>
                <div>
                  <div className="text-[#0D062D] text-xl">
                    {t("welcome_to_projectchef")}
                  </div>
                  <div className="text-sm text-gray-450 truncate w-fit">
                    {t("please_follow_the_steps_to_get_started")}
                  </div>
                </div>
              </div>
            )}
          {urlLocation == "mytasks" && t("mytask")}
          {urlLocation == "my-timesheet" && t("my_timesheet")}
          {urlLocation == "timesheet-approvals" && t("timesheet_approvals")}
          {urlLocation == "cra-dashboard" && (
            <div className="flex items-center gap-2">
              <span className="text-slate-400 font-medium normal-case">{t("CRA Dashboard") || "Timesheet Dashboard"}</span>
              <span className="text-slate-300 text-xs font-semibold normal-case">&gt;</span>
              <span className="text-slate-800 font-bold normal-case">
                {(() => {
                  const tab = new URLSearchParams(location.search).get("tab");
                  if (tab === "team") return t("By teams") || "By teams";
                  if (tab === "activity") return t("Activity analysis") || "Activity analysis";
                  return t("Overview") || "Overview";
                })()}
              </span>
            </div>
          )}
          {urlLocation == "checkout" && t("checkout")}
          {urlLocation == "projects" &&
            projectQuery.data &&
            projectQuery.data?.data.data?.length > 0 &&
            t("project_list")}
          {urlLocation == "" && t("portfolio_dashboard")}
          {urlLocation == "organisation" && !organisationId && (
            <div className="flex items-center">
              <div>👋</div>
              <div>
                <div className="text-[#0D062D] text-xl">
                  {t("welcome_to_projectchef")}
                </div>
                <div className="text-sm text-gray-450 truncate w-[">
                  {t("please_follow_the_steps_to_get_started")}
                </div>
              </div>
            </div>
          )}
          {window.location.pathname.includes("scales") && (
            <div className="text-base flex gap-5 items-center">
              <img
                src={BackIcon}
                className="h-6 cursor-pointer min-h-6 ml-3"
                onClick={() => window.history.back()}
              />
              {t("Impact and Probability Scales")}
            </div>
          )}
        </div>

        <div className="right flex gap-3 items-center ">
          <div className="flex gap-2 items-center">
            {(user?.userOrganisation[0]?.role ==
              UserRoleEnumValue.ADMINISTRATOR ||
              projectQuery.data?.data.data.some((item) =>
                item.assignedUsers.find(
                  (u) =>
                    u.user.userId == user?.userId &&
                    u.projectRole == UserRoleEnumValue.PROJECT_MANAGER,
                ),
              )) && (
                <button
                  onClick={() =>
                    window.open(
                      "https://calendly.com/projectchef/45min",
                      "_blank",
                    )
                  }
                  className="!truncate text-white px-4 h-8 text-xs font-bold rounded-lg bg-gradient-to-r from-[#535EF9] to-[#3B82F6] hover:from-[#4650DF] hover:to-[#3172E9] shadow-[0_2px_8px_-2px_rgba(83,94,249,0.35)] flex items-center justify-center transition-all duration-300 hover:scale-[1.02] border-0"
                >
                  <img src={PhoneTelephone} className="mr-1.5 h-3.5 w-3.5 invert shrink-0" />
                  {t("Book an onboarding call")}
                </button>
              )}
            <DropdownMenu>
              <DropdownMenuTrigger className="px-3.5 h-8 justify-center rounded-lg border border-slate-200/80 flex items-center gap-1.5 text-xs font-bold text-slate-600 bg-white hover:bg-slate-50 transition-all duration-300 hover:scale-[1.02] cursor-pointer focus:outline-none shadow-sm">
                <img src={HelpIcon} className="h-3.5 w-3.5 shrink-0" />
                {t("help")}
              </DropdownMenuTrigger>
              <DropdownMenuContent className="!overflow-y-auto !max-h-[600px] !w-64">
                <DropdownMenuItem asChild className="p-0">
                  <Button
                    variant={"none"}
                    onClick={() => setIsShowVideo(true)}
                    className="text-primary-500 underline w-full !justify-start"
                  >
                    {t("Presentation")}
                  </Button>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="p-0">
                  <Button
                    variant={"none"}
                    onClick={() => setIsShowRiskVideo(true)}
                    className="text-primary-500 underline w-full !justify-start"
                  >
                    {t("Risk Management")}
                  </Button>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="p-0">
                  <Button
                    variant={"none"}
                    onClick={() => setRoadmapVideo(true)}
                    className="text-primary-500 underline w-full !justify-start"
                  >
                    {t("rode_map")}
                  </Button>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="p-0">
                  <Button
                    variant={"none"}
                    onClick={() =>
                      window.open(
                        "https://projectchef.io/contact-us/",
                        "_blank",
                      )
                    }
                    className="text-primary-500 underline w-full !justify-start"
                  >
                    {t("Contact us")}
                  </Button>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
          {/* Removed as not needed in new design DT: 09-01-2026 */}
          {/* <div className=" ">
            <a
              className="text-primary-500 text-sm underline flex items-center gap-0.5 pointer text-nowrap underline-offset-2"
              target="_blank"
              href="https://projectchef.io/user-voice/"
            >
              <img
                src={NewMessageQuestion}
                className="min-w-7 align-middle rounded-full"
                alt="No Image Found"
              />
              {t("share_your_feedback")}
            </a>
          </div> */}
          <div className="notification">
            {!isOpenPopUpRead && (
              <div className="relative">
                <DropdownMenu
                  open={notificationDropdownOpen}
                  onOpenChange={(open) => {
                    setNotificationDropdownOpen(open);
                    if (!open) {
                      setNotificationListExpanded(false);
                    }
                  }}
                >
                  <DropdownMenuTrigger asChild>
                    <button className="relative w-8 h-8 rounded-full bg-slate-50border-slate-100 hover:bg-slate-100 hover:scale-105 flex items-center justify-center cursor-pointer transition-all duration-300 border-0 focus:outline-none shadow-sm">
                      <img
                        src={
                          notifications?.length > 1
                            ? NewNotificationBellDot
                            : NewNotificationBell
                        }
                        className="w-4.5 h-4.5 object-contain"
                      />
                      {notifications && notifications.length > 0 && (
                        <div className="min-w-4 h-4 px-1 rounded-full bg-red-600 absolute -top-0.5 -right-0.5 text-[8px] flex justify-center items-center text-white font-bold leading-none border border-white">
                          {notifications.length <= 99
                            ? notifications.length
                            : "99+"}
                        </div>
                      )}
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent
                    align="end"
                    className="w-[min(100vw-1.5rem,28rem)] min-w-[22rem] max-w-[28rem] overflow-hidden p-0 shadow-lg"
                  >
                    <div className="flex max-h-[min(80vh,720px)] flex-col">
                      <div className="flex shrink-0 flex-wrap items-center justify-between gap-3 border-b border-gray-100 px-5 py-4">
                        <DropdownMenuLabel className="!m-0 !p-0 text-lg font-bold text-gray-900">
                          {t("notifications")}
                        </DropdownMenuLabel>
                        {mergedDropdownNotifications.length > 0 && (
                          <div className="flex shrink-0 flex-wrap items-center justify-end gap-3">
                            {mergedDropdownNotifications.some((n) => !n.isRead) && (
                              <button
                                type="button"
                                className="text-[15px] font-medium text-blue-600 hover:underline"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setisOpenPopUpRead(true);
                                }}
                              >
                                {t("notification_mark_all_read")}
                              </button>
                            )}
                            <button
                              type="button"
                              className="text-[15px] font-medium text-gray-600 hover:underline"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setIsOpenClearAllNotifications(true);
                              }}
                            >
                              {t("notification_clear_all")}
                            </button>
                          </div>
                        )}
                      </div>
                      <div
                        className={
                          notificationListExpanded
                            ? "min-h-0 max-h-[min(28rem,60vh)] overflow-y-auto overscroll-contain"
                            : "overflow-hidden"
                        }
                        onWheel={(e) => e.stopPropagation()}
                      >
                        {notificationHistoryQuery.isLoading &&
                          mergedDropdownNotifications.length === 0 ? (
                          <div className="flex justify-center px-5 py-10">
                            <Spinner />
                          </div>
                        ) : mergedDropdownNotifications.length > 0 ? (
                          <>
                            {displayedDropdownNotifications.map(
                              (notification) => (
                                <DropdownMenuItem
                                  key={notification.notificationId}
                                  className="group relative cursor-pointer rounded-none border-b border-gray-100 px-5 py-4 focus:bg-gray-50 data-[highlighted]:bg-gray-50"
                                  onSelect={(e) => {
                                    e.preventDefault();
                                    void handleNotificationNavigateAndRead(
                                      notification,
                                    );
                                  }}
                                >
                                  <div className="relative flex w-full items-start pr-9">
                                    <div className="min-w-0 flex-1">
                                      <NotificationRowContent
                                        notification={notification}
                                      />
                                    </div>
                                    <button
                                      type="button"
                                      className="absolute right-0 top-1/2 z-10 -translate-y-1/2 rounded-md p-1.5 text-gray-400 opacity-0 transition hover:bg-gray-200 hover:text-gray-700 group-hover:opacity-100 group-data-[highlighted]:opacity-100"
                                      aria-label={t("notification_delete_one")}
                                      onPointerDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleDeleteNotification(
                                          e as unknown as MouseEvent,
                                          notification,
                                        );
                                      }}
                                    >
                                      <Trash2 className="h-4 w-4 shrink-0" />
                                    </button>
                                  </div>
                                </DropdownMenuItem>
                              ),
                            )}
                          </>
                        ) : (
                          <div className="px-5 py-10 text-center text-[15px] text-gray-500 sm:text-base">
                            {notificationHistoryQuery.isError
                              ? t("something_went_wrong")
                              : t("no_notification_found")}
                          </div>
                        )}
                      </div>
                      {showViewAllNotificationsFooter && (
                        <div
                          className="shrink-0 border-t border-gray-100 px-5 py-3.5 text-center"
                          onPointerDown={(e) => e.stopPropagation()}
                        >
                          <button
                            type="button"
                            className="inline-flex items-center gap-1.5 text-[15px] font-medium text-blue-600 hover:underline sm:text-base"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setNotificationListExpanded(true);
                            }}
                          >
                            {t("notification_view_all")}
                            <ChevronRight
                              className="h-5 w-5 shrink-0"
                              aria-hidden
                            />
                          </button>
                        </div>
                      )}
                    </div>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            )}
            {isOpenPopUpRead && (
              <Dialog
                isOpen={isOpenPopUpRead}
                onClose={() => setisOpenPopUpRead(false)}
                hasBackdropClose={true}
                hasEscClose={true}
                modalClass="rounded-xl max-w-sm w-full shadow-2xl border border-gray-100/50"
              >
                <div className="flex flex-col items-center text-center p-6 gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 text-blue-600">
                    <CheckCircle2 className="h-6 w-6" />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <h3 className="text-lg font-bold text-gray-900 leading-none">
                      {t("notification_mark_all_read") || "Mark all as read"}
                    </h3>
                    <p className="text-sm text-gray-500 max-w-xs leading-relaxed">
                      {t("read_all_notifications")}
                    </p>
                  </div>
                  <div className="flex w-full gap-3 mt-2">
                    <Button
                      variant="outline"
                      className="flex-1 rounded-lg border border-gray-300 font-medium hover:bg-gray-50 h-10 text-sm"
                      isLoading={useReadAllNotification.isPending}
                      disabled={useReadAllNotification.isPending}
                      onClick={() => setisOpenPopUpRead(false)}
                    >
                      {t("cancel")}
                    </Button>
                    <Button
                      variant="primary"
                      className="flex-1 rounded-lg bg-blue-600 font-medium text-white hover:bg-blue-700 shadow-md shadow-blue-100 h-10 text-sm"
                      onClick={() => {
                        handleReadAll();
                        setisOpenPopUpRead(false);
                      }}
                      isLoading={useReadAllNotification.isPending}
                      disabled={useReadAllNotification.isPending}
                    >
                      {t("yes")}
                    </Button>
                  </div>
                </div>
              </Dialog>
            )}
            {isOpenClearAllNotifications && (
              <Dialog
                isOpen={isOpenClearAllNotifications}
                onClose={() => setIsOpenClearAllNotifications(false)}
                hasBackdropClose={true}
                hasEscClose={true}
                modalClass="rounded-xl max-w-sm w-full shadow-2xl border border-gray-100/50"
              >
                <div className="flex flex-col items-center text-center p-6 gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
                    <AlertTriangle className="h-6 w-6" />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <h3 className="text-lg font-bold text-gray-900 leading-none">
                      {t("notification_clear_all") || "Clear all"}
                    </h3>
                    <p className="text-sm text-gray-500 max-w-xs leading-relaxed">
                      {t("notification_confirm_clear_all")}
                    </p>
                  </div>
                  <div className="flex w-full gap-3 mt-2">
                    <Button
                      variant="outline"
                      className="flex-1 rounded-lg border border-gray-300 font-medium hover:bg-gray-50 h-10 text-sm"
                      isLoading={clearAllNotificationsMutation.isPending}
                      disabled={clearAllNotificationsMutation.isPending}
                      onClick={() => setIsOpenClearAllNotifications(false)}
                    >
                      {t("cancel")}
                    </Button>
                    <Button
                      variant="primary"
                      className="flex-1 rounded-lg bg-red-600 font-medium text-white hover:bg-red-750 shadow-md shadow-red-100 h-10 text-sm"
                      onClick={() => handleClearAllNotificationsConfirmed()}
                      isLoading={clearAllNotificationsMutation.isPending}
                      disabled={clearAllNotificationsMutation.isPending}
                    >
                      {t("yes")}
                    </Button>
                  </div>
                </div>
              </Dialog>
            )}
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild className="pr-1.5">
              <div
                className={`profileDetails flex items-center gap-2 cursor-pointer transition-all duration-300 hover:scale-105 hover:opacity-90 ${notifications.length > 0 ? "ml-1.5" : "ml-0"
                  }`}
              >
                <div className="rounded-full border border-gray-200 shrink-0">
                  <UserAvatar user={user} className="w-7 h-7" fontClass="text-[10px]" />
                </div>
                {/* {!isMobailView && (
                  <div className="flex flex-col items-start">
                    <div className="text-base text-[#0D062D] font-medium">
                      {user?.firstName}
                    </div>
                    <div className="text-sm text-gray-450">
                      {countries.find((d) => d.isoCode == user?.country)?.name}
                    </div>
                  </div>
                )} */}
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-auto  rounded-lg shadow-lg border border-gray-100 p-2 pt-4 pl-2 mr-4">
              <DropdownMenuItem
                asChild
                className="disabled:cursor-not-allowed rounded-md hover:bg-gray-50 cursor-pointer"
                disabled={Boolean(!user?.userOrganisation[0])}
              >
                <Button
                  variant={"none"}
                  className="flex w-full justify-start p-0 h-fit"
                  onClick={() => navigate("/account-settings")}
                >
                  <img src={UserIcon} className="mr-3 h-4 w-4" />
                  <span className="text-sm text-gray-700 font-semibold">{t("portfolio_details")}</span>
                </Button>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              {user?.userOrganisation[0]?.role &&
                user?.userOrganisation[0]?.role ==
                UserRoleEnumValue.ADMINISTRATOR && (
                  <DropdownMenuItem asChild onClick={() => navigate("/plans")} className="rounded-md hover:bg-gray-50 cursor-pointer">
                    <Button
                      className="p-0 flex w-full justify-start h-fit"
                      variant={"none"}
                    >
                      <img src={MySubscription} className="mr-3 h-4 w-4" />
                      <span className="text-sm text-gray-700 font-semibold">{t("MySubscriptions")}</span>
                    </Button>
                  </DropdownMenuItem>
                )}
              <DropdownMenuSeparator />
              <DropdownMenuItem asChild className="rounded-md hover:bg-gray-50 cursor-pointer">
                <Button
                  variant={"none"}
                  className="p-0 flex w-full justify-start h-fit"
                  onClick={logout}
                >
                  <img
                    className="mr-3 h-4 w-4"
                    src={NewLogout}
                    alt="No Image Found"
                  />
                  <span className="text-sm text-gray-700 font-semibold">{t("logout")}</span>
                </Button>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      {/* <Dialog
        isOpen={openMySubscriptions}
        onClose={() => {
          setOpenMySubscriptions(false);
        }}
        modalClass="rounded-lg px-5"
      >
        <PaymentPlans
          onClose={() => {
            setOpenMySubscriptions(false);
          }}
        />
      </Dialog> */}
      <Dialog
        isOpen={isPaymentSuccess.loading}
        onClose={() => {
          // setOpenMySubscriptions(false);
        }}
        modalClass="rounded-lg "
      >
        <div className=" w-80 h-fit flex flex-col gap-6 p-8 relative">
          {isPaymentSuccess.status == "ERROR" && (
            <div
              className="flex justify-end cursor-pointer items-center w-full h-1/4"
              onClick={() => {
                setIsPaymentSuccess({ loading: false, status: "PENDING" });
              }}
            >
              <img src={crossNew} className="w-4 max-w-4" />
            </div>
          )}
          <div className="flex justify-center  w-full h-3/4   items-center">
            {isPaymentSuccess.status === "SUCCESS" ? (
              <div className="flex justify-center items-center animate-fadeInScale rounded-full w-fit h-fit p-4 bg-green-500/50">
                <img src={GreenChackMark} className="w-20 h-20" />
              </div>
            ) : isPaymentSuccess.status == "PENDING" ? (
              <Spinner color="#535EF9" className="h-20 w-20" />
            ) : (
              <div className="flex justify-center items-center animate-fadeInScale rounded-full w-fit h-fit p-4 bg-red-500/50">
                <img src={RedCharmTick} className="w-20 h-20" />
              </div>
            )}
          </div>
          <div className="text-center text-xl font-semibold">
            {isPaymentSuccess.status === "SUCCESS"
              ? t("Payment Success")
              : isPaymentSuccess.status == "PENDING"
                ? t("Payment is in progress")
                : "Payment Failed"}
            <div className="text-center text-sm text-gray-450">
              {isPaymentSuccess.status === "SUCCESS" ? (
                <div className="flex flex-col gap-2">
                  <p>{t("Your subscription is active now")}</p>
                  <Button
                    onClick={() => {
                      setIsPaymentSuccess({
                        loading: false,
                        status: "PENDING",
                      });
                      // setOpenMySubscriptions(false);
                      projectQuery.refetch();
                      setFilter({});
                    }}
                    variant={"primary"}
                  >
                    {t("Ok")}
                  </Button>
                </div>
              ) : isPaymentSuccess.status == "PENDING" ? (
                t("Please wait while we process your payment")
              ) : (
                <div className="flex flex-col gap-2">
                  <p>{t("Please try again")}</p>
                  <Button
                    onClick={() => {
                      setIsPaymentSuccess({
                        loading: false,
                        status: "PENDING",
                      });
                      // setOpenMySubscriptions(true);
                      navigate("/plans");
                      setFilter({});
                    }}
                    variant={"primary"}
                  >
                    {t("Try again")}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={confirmDashboard}
        onClose={() => { }}
        modalClass="rounded-lg "
        bgClass="!backdrop-blur-sm"
      >
        <div className="flex flex-col gap-4 p-6 w-96 text-center ">
          {(!user?.userOrganisation[0]?.role ||
            user?.userOrganisation[0]?.role ==
            UserRoleEnumValue.COLLABORATOR) &&
            t(
              "You do not have access to this dashboard with your current plan. Please contact your administrator to upgrade the current plan",
            )}
          {user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR &&
            t(
              urlLocation == ""
                ? "Portfolio dashboard are not available in this plan. Do you want to upgrade your plan?"
                : urlLocation == "risk"
                  ? "Risk management module is not available in this plan. Do you want to upgrade your plan?"
                  : urlLocation == "capacity-planning"
                    ? "Capacity Planning"
                    : urlLocation == "workload"
                      ? "Workload module is not available in this plan. Do you want to upgrade your plan?"
                      : urlLocation == "my-timesheet" ||
                        urlLocation == "timesheet-approvals"
                        ? "Timesheet feature is only accessible with an Enterprise subscription. Do you want to upgrade your plan?"
                        : "Project dashboard are not available in this plan. Do you want to upgrade your plan?",
            )}
          <div className="flex gap-2 ml-auto">
            {!user?.userOrganisation[0]?.role ||
              user?.userOrganisation[0]?.role ==
              UserRoleEnumValue.COLLABORATOR ? (
              <Button
                variant={"outline"}
                onClick={() => {
                  (setConfirmDashboard(false), navigate("/projects"));
                }}
              >
                {t("ok")}
              </Button>
            ) : (
              <>
                <Button
                  variant={"outline"}
                  onClick={() => {
                    (setConfirmDashboard(false), navigate("/projects"));
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant={"primary"}
                  // onClick={removeTask}.
                  className={"text-white"}
                  onClick={() => {
                    navigate("/plans");
                  }}
                >
                  {t("Upgrade")}
                </Button>
              </>
            )}
          </div>
        </div>
      </Dialog>
      {isShowVideo && (
        <Dialog
          isOpen={isShowVideo}
          onClose={() => { }}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative"
        >
          <div className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30">
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer close"
              onClick={() => {
                (setIsShowVideo(false), setIsTutorialShow());
              }}
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/998692707?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
      {isShowRiskVideo && (
        <Dialog
          isOpen={isShowRiskVideo}
          onClose={() => { }}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative "
        >
          <div
            className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30 close"
            onClick={() => setIsShowRiskVideo(false)}
          >
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/1054493760?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
      {roadmapVideo && (
        <Dialog
          isOpen={roadmapVideo}
          onClose={() => { }}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative "
        >
          <div
            className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30 close"
            onClick={() => setRoadmapVideo(false)}
          >
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/1083552233?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
    </>
  );
};
